// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__115k5","col":"styles_col__1BFcQ","fulfillmentStatus":"styles_fulfillmentStatus__27tPa","emailCol":"styles_emailCol__2gBET"};